export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAECAYAAAAqNadFAAAAGUlEQVR4XmPQ1tb+P1wxA7rAcMKjnhuqGADXdEoQwen6owAAAABJRU5ErkJggg=="